import { render, staticRenderFns } from "./ViewPlotDetails300.vue?vue&type=template&id=518b36dd"
import script from "./ViewPlotDetails300.vue?vue&type=script&lang=ts"
export * from "./ViewPlotDetails300.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports